import { hexToRgb, getLuminance, safe } from '../utils/contrast.js';
import { estiloDeBoton } from '../utils/boton-estilo.js';
import { ctaAnchorAttrs } from '../utils/links.js';
import { conSecundario } from '../utils/boton-secundario.js';
import { altAttr } from '../utils/alt-text.js';
import { t } from '../utils/i18n.js';
import { dimensionesDe, atributosDimension, asasCaja, asaTexto, cajaUnicaDe, atributosCajaUnica, asasCajaUnica } from '../utils/dimension.js';
import { clasesImagenRecorte } from '../utils/imagen-recorte.js';
import { atributosEncuadre } from '../utils/encuadre.js';

    export const contentBlock = (rawProps) => {
        const p = safe(rawProps);
        const placeholder = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=";

        let query = p.image_url || p.image_keyword || "";

        // ¿Se puede redimensionar a mano? Solo las variantes de DOS COLUMNAS (v1/v3) y solo
        // cuando hay imagen: sin ella no hay fila que repartir. La lista vive en
        // utils/dimension.js (SSOT compartida con el editor), no aquí.
        //
        // CONTRATO DE MARKUP DEL MOTOR DE DIMENSIÓN (ver utils/dimension.js): la fila lleva
        // `n3i-fila`; las dos columnas, `n3i-texto` y `n3i-media`, cada una con su `data-interior`
        // (el borde que da a la vecina, del que sale el ANCLAJE y el signo del arrastre); el texto
        // va dentro de una `n3i-caja-texto` y la foto dentro de una `n3i-caja` (el rótulo de carga
        // se queda FUERA: si la caja lo incluyera, el alto que el cliente arrastra mediría foto +
        // rótulo). Las clases `n3i-dim*` y las variables las emiten
        // `clasesDimension`/`estiloDimension` — y SOLO cuando hay prop, así que un sitio ya
        // generado sale igual que siempre.
        const dim = p.use_image ? dimensionesDe('content', p.variant || 'v1') : null;
        const dimAttrs = atributosDimension(p, dim);   // {clases, estilo}, una sola pasada
        // SIN imagen no hay fila: la caja de 850 px es la CAJA DE TEXTO ÚNICA (utils/dimension.js),
        // centrada, y su 100 % es el «Ancho del contenido» de la sección (o la sección si no lo hay).
        const fichaU = p.use_image ? null : cajaUnicaDe('content', p.variant || 'v1');
        const u = atributosCajaUnica(p, fichaU);
        // Lado INTERIOR de cada columna = el que da a la vecina. En v1 el texto va a la izquierda
        // (su interior es el ESTE) y la imagen a la derecha (interior OESTE); en v3 la fila va
        // `row-reverse` (imagen izquierda, texto derecha) y se invierten. Cada caja se ancla al
        // borde CONTRARIO —el exterior, clavado al padding de la sección—, así que el borde que se
        // arrastra es el que se mueve.
        const interiorMedia = p.variant === 'v3' ? 'e' : 'w';
        const interiorTexto = p.variant === 'v3' ? 'w' : 'e';

        // Encuadre (utils/encuadre.js, D-1429 B): foco + zoom; sin prop, nada.
        const enc = atributosEncuadre(p);
        const imgTag = `<img src="${placeholder}" ${altAttr(p.image_alt, p.title, p.text, p.image_keyword)} data-unsplash="${query}" class="unsplash-target${clasesImagenRecorte(p)}${enc.clase}" style="width: 100%; border-radius: var(--card-radius, 24px); box-shadow: var(--shadow-card, 0 20px 40px rgba(0,0,0,0.15)); object-fit: cover; aspect-ratio: 16/9; transition: opacity 0.5s; opacity: 0;${enc.estilo}">`;

        const imgHtml = p.use_image ? `
        <div class="content-image-side${dim ? ' n3i-media' : ''}"${dim ? ` data-interior="${interiorMedia}"` : ''} style="flex: ${dim ? 'var(--media-flex, 1.15) 1 0' : '1'}; min-width: min(100%, 300px); position: relative;">
            ${dim ? `<div class="n3i-caja">${imgTag}${asasCaja(dim, interiorMedia)}</div>` : imgTag}
            <div class="loading-label" style="margin-top: 20px; font-size: 0.8rem; opacity: 0.5; text-align: center; font-style: italic;">${t('loading_asset')}</div>
        </div>` : "";

        // Dónde va el botón en la columna (y, con secundario, la fila de los dos: utils/boton-secundario.js).
        const alineaBoton = p.variant === 'v2' && !p.use_image ? 'center' : (p.variant === 'v3' && !p.use_image ? 'flex-end' : 'flex-start');
        const textoDentro = `
        <h2 data-field="title" contenteditable="true" style="font-size: calc(clamp(2rem, 4cqw, 3.5rem) * var(--type-scale, 1)); font-weight: 800; margin-bottom: 25px; line-height: 1.2;">
            ${p.title || 'Nuestra Historia'}
        </h2>
        <p data-field="text" contenteditable="true" style="font-size: calc(1.15rem * var(--text-scale, 1)); line-height: 1.8; opacity: 0.85;">
            ${p.text || 'Descripción detallada de la sección.'}
        </p>
        ${conSecundario(p.cta ? `<a ${ctaAnchorAttrs(p.cta_url)} class="btn-action" data-field="cta" contenteditable="true" style="${estiloDeBoton(p, 'cta')}margin-top: 30px; align-self: ${alineaBoton};">  ${p.cta}</a>` : '', p, { fila: `margin-top: 30px; align-self: ${alineaBoton};` })}`;

        // La CAJA DEL TEXTO se lleva el `display:flex; flex-direction:column` que era de la
        // columna: así el `align-self` del botón sigue resolviéndose contra el MISMO eje y, sin
        // ningún prop, la geometría es idéntica a la de antes (la caja es transparente). La
        // columna conserva su `justify-content:center`, que ahora centra la caja entera.
        const textHtml = `
    <div class="content-text-side${dim ? ' n3i-texto' : ''}"${dim ? ` data-interior="${interiorTexto}"` : ''} style="flex: var(--text-flex, 1) 1 0; min-width: min(100%, 300px); position: relative; display: flex; flex-direction: column; justify-content: center; text-align: ${p.use_image ? 'left' : (p.variant === 'v2' ? 'center' : (p.variant === 'v3' ? 'right' : 'left'))};">
        ${dim ? `<div class="n3i-caja-texto" style="display: flex; flex-direction: column;">${textoDentro}${asaTexto(interiorTexto)}</div>` : textoDentro}
    </div>`;

        // LÓGICA DE CONTENEDOR FLEXIBLE
        // (El `--n3i-gap` que se declaraba aquí era para el DIVISOR, que se colocaba a media
        // separación de la columna. Sin divisor no lo lee nadie: el hueco vuelve a ser un número.)
        let flexStyle = "display: flex; flex-wrap: wrap; gap: 60px; align-items: center;";
        let contentLayout = "";
        const claseFila = dim ? ' class="n3i-fila"' : '';

        if (!p.use_image) {
            contentLayout = `<div${u.claseCaja ? ` class="${u.claseCaja}"` : ''} style="max-width: 850px; margin: 0 auto;">${textHtml}${asasCajaUnica(fichaU)}</div>`;
        } else {
            if (p.variant === 'v3') {
                // v3: Imagen Izquierda, Texto Derecha (row-reverse porque en el DOM el texto suele ir primero para SEO/Accesibilidad)
                flexStyle += " flex-direction: row-reverse;";
                contentLayout = `<div${claseFila} style="${flexStyle}">${textHtml}${imgHtml}</div>`;
            } else if (p.variant === 'v2') {
                // v2: Imagen Arriba, Texto Abajo (Stack vertical)
                flexStyle += " flex-direction: column; text-align: center;";
                contentLayout = `<div style="${flexStyle} max-width: 900px; margin: 0 auto;">${imgHtml}${textHtml}</div>`;
            } else {
                // v1 (Default): Texto Izquierda, Imagen Derecha
                contentLayout = `<div${claseFila} style="${flexStyle}">${textHtml}${imgHtml}</div>`;
            }
        }

        return `
    <section id="bloque-content" class="reveal variant-${p.variant || 'v1'}${dimAttrs.clases}${u.clases}" style="--bg:${p.bgColor}; --text:${p.textColor}; --accent:${p.accentColor}; --font:'${p.fontFamily || "Inter"}'; --accent-contrast:${p.accentContrast};${dimAttrs.estilo}${u.estilo} padding: 100px 8%;">
        <style>
          @media (max-width: 992px) {
              .content-text-side { text-align: center !important; margin-bottom: 40px; }
              .content-text-side .btn-action { align-self: center !important; }
              .content-image-side { width: 100% !important; margin: 0 auto !important; display: flex; justify-content: center; }
          }
        </style>
        ${contentLayout}
    </section>`;
    }
